module.exports = __webpack_public_path__ + "static/img/player_04_program.bee4d84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/player_04_program.svg
// module id = VnsY
// module chunks = 0